import * as yup from 'yup';

let unitSchema = yup.object().shape({
  textBoxValue: yup
    .number()
    ?.nullable()
    .transform((value, originalValue) => {
      // if (!originalValue) return null;
      if (originalValue === '' || originalValue === null || originalValue === undefined)
        return null;

      return parseFloat(originalValue);
    })
    .test('textBoxValueRequired', 'Required', function (value) {
      const { textBoxUnitValue } = this.parent;

      if (textBoxUnitValue && (value === null || value === undefined || value === '')) {
        return false;
      }

      return true;
    }),
  textBoxUnitValue: yup
    .string()
    ?.nullable()
    .test('textBoxUnitRequired', 'Unit is required if value is provided', function (value) {
      const { textBoxValue } = this.parent;

      // if value is entered but unit is not, show error
      if (textBoxValue !== null && textBoxValue !== undefined && textBoxValue !== '' && !value) {
        return false;
      }

      return true;
    })
});
let unitReconcileSchema = yup.object().shape({
  textBoxValue: yup
    .number()
    ?.nullable()
    .transform((value, originalValue) => {
      // if (!originalValue) return null;
      if (originalValue === '' || originalValue === null || originalValue === undefined)
        return null;

      return parseFloat(originalValue);
    }),
  textBoxUnitValue: yup.string()?.nullable()
});

const defaultValueOfUnit = {
  textBoxValue: null,
  textBoxUnitValue: ''
};

const addEditCMLSchema = {
  cmlNumber: yup.string().required('cml number is required'),
  component: yup.string().required('component is required'),
  location: yup.string().required('location is required'),
  orientation: yup.string().required('orientation is required'),
  material: yup.string().nullable(),
  schedule: yup.string().nullable(),
  outsideDiameter: unitSchema,
  nominalDiameter: unitSchema,
  wallThickness: unitSchema,
  tmin: unitSchema,

  outsideDiameterOnMM: unitSchema,
  nominalDiameterOnMM: unitSchema,
  wallThicknessOnMM: unitSchema,
  tminOnMM: unitSchema,
  // reconcile
  'cmlNumber-reconcile': yup.string(),
  'component-reconcile': yup.string(),
  'location-reconcile': yup.string(),
  'orientation-reconcile': yup.string(),
  'material-reconcile': yup.string(),
  'schedule-reconcile': yup.string(),

  'outsideDiameter-reconcile': unitReconcileSchema,
  'nominalDiameter-reconcile': unitReconcileSchema,
  'wallThickness-reconcile': unitReconcileSchema,
  'tmin-reconcile': unitReconcileSchema,

  'outsideDiameterOnMM-reconcile': unitReconcileSchema,
  'nominalDiameterOnMM-reconcile': unitReconcileSchema,
  'wallThicknessOnMM-reconcile': unitReconcileSchema,
  'tminOnMM-reconcile': unitReconcileSchema
};

const defaultValuesOfCML = {
  cmlNumber: '',
  component: '',
  location: '',
  orientation: '',
  material: '',
  schedule: '',

  outsideDiameter: defaultValueOfUnit,
  nominalDiameter: defaultValueOfUnit,
  wallThickness: defaultValueOfUnit,
  tmin: defaultValueOfUnit,

  outsideDiameterOnMM: defaultValueOfUnit,
  nominalDiameterOnMM: defaultValueOfUnit,
  wallThicknessOnMM: defaultValueOfUnit,
  tminOnMM: defaultValueOfUnit
};

const getFormFieldsOfCML = ({ dropdownMenuMapList, isReconcile, selectedUnit }) => {
  return [
    {
      label: 'CML #',
      name: 'cmlNumber',
      type: 'Text',
      required: true,
      isReadOnly: false,
      isMasterData: isReconcile,
      order: 1
    },

    {
      label: 'Component',
      name: 'component',
      type: 'Dropdown',
      required: true,
      isReadOnly: false,
      isMasterData: isReconcile,
      options: dropdownMenuMapList?.CMLComponentPickList || [],
      order: 2
    },

    {
      label: 'Location',
      name: 'location',
      type: 'Dropdown',
      required: true,
      isReadOnly: false,
      isMasterData: isReconcile,
      options: dropdownMenuMapList?.CMLLocationPickList || [],
      order: 3
    },

    {
      label: 'Orientation',
      name: 'orientation',
      type: 'Dropdown',
      required: true,
      isReadOnly: false,
      isMasterData: isReconcile,
      options: dropdownMenuMapList?.OrientationTypePickList || [],
      order: 4
    },

    {
      label: 'Material',
      name: 'material',
      type: 'Dropdown',
      required: false,
      isReadOnly: false,
      isMasterData: isReconcile,
      options: dropdownMenuMapList?.ConstructionMaterialPickList || [],
      order: 5
    },

    {
      label: 'Schedule',
      name: 'schedule',
      type: 'Dropdown',
      required: false,
      isReadOnly: false,
      isMasterData: isReconcile,
      options: dropdownMenuMapList?.UltrasonicTestingCMLSchedulePickList || [],
      order: 6
    },

    {
      isMasterData: isReconcile,
      label: 'Outside diameter',
      name: selectedUnit === 'mm' ? 'outsideDiameterOnMM' : 'outsideDiameter',
      type: 'Readings',
      required: false,
      options: dropdownMenuMapList?.SmallMeasurementPickListForCML || [],
      order: 7
    },

    {
      isMasterData: isReconcile,
      label: 'Nominal Diameter',
      name: selectedUnit === 'mm' ? 'nominalDiameterOnMM' : 'nominalDiameter',
      type: 'Readings',
      required: false,
      options: dropdownMenuMapList?.SmallMeasurementPickListForCML || [],
      order: 8
    },

    {
      isMasterData: isReconcile,
      label: 'Wall thickness',
      name: selectedUnit === 'mm' ? 'wallThicknessOnMM' : 'wallThickness',
      type: 'Readings',
      required: false,
      options: dropdownMenuMapList?.SmallMeasurementPickListForCML || [],
      order: 9
    },

    {
      isMasterData: isReconcile,
      label: 'Tmin',
      name: selectedUnit === 'mm' ? 'tminOnMM' : 'tmin',
      type: 'Readings',
      required: false,
      options: dropdownMenuMapList?.SmallMeasurementPickListForCML || [],
      order: 10
    }
  ];
};

const addEditReadingSchema = {
  minReading: yup.object().shape({
    textBoxValue: yup
      .number()
      ?.nullable()
      .transform((value, originalValue) => {
        // if (!originalValue) return null;
        if (originalValue === '' || originalValue === null || originalValue === undefined)
          return null;

        return parseFloat(originalValue);
      })
      .required('required'),
    textBoxUnitValue: yup.string()?.nullable().required('required')
  }),

  avgReading: yup.object().shape({
    textBoxValue: yup
      .number()
      ?.nullable()
      .transform((value, originalValue) => {
        // if (!originalValue) return null;
        if (originalValue === '' || originalValue === null || originalValue === undefined)
          return null;

        return parseFloat(originalValue);
      })
      .required('required'),
    textBoxUnitValue: yup.string()?.nullable().required('required')
  }),

  lastAverageReadingInches: yup.string(),
  lastAverageReadingMillimetres: yup.string(),
  lastMinimumReadingInches: yup.string(),
  lastMinimumReadingMillimetres: yup.string(),

  comments: yup.string().nullable()
};

const defaultValuesOfReading = {
  comments: '',
  minReading: {
    textBoxValue: null,
    textBoxUnitValue: ''
  },
  avgReading: {
    textBoxValue: null,
    textBoxUnitValue: ''
  }
};

const getFormFieldsOfReading = ({ dropdownMenuMapList }) => {
  return [
    {
      isMasterData: false,
      label: 'Min. reading',
      name: 'minReading',
      type: 'Readings',
      required: true,
      options: dropdownMenuMapList?.SmallMeasurementPickListForCML || [],
      order: 1
    },
    {
      isMasterData: false,
      label: 'Last min. reading',
      name: 'lastMinimumReadingInches',
      name2: 'lastMinimumReadingMillimetres',
      parentName: 'minReading.textBoxUnitValue',
      type: 'Box',
      required: false,
      order: 2
    },

    {
      isMasterData: false,
      label: 'Avg. reading',
      name: 'avgReading',
      type: 'Readings',
      required: true,
      options: dropdownMenuMapList?.SmallMeasurementPickListForCML || [],
      order: 3
    },

    {
      isMasterData: false,
      label: 'Last AVG. reading',
      name: 'lastAverageReadingInches',
      name2: 'lastAverageReadingMillimetres',
      parentName: 'avgReading.textBoxUnitValue',

      type: 'Box',
      required: false,
      order: 4
    },
    {
      isMasterData: false,
      label: 'Comments',
      name: 'comments',
      required: false,
      type: 'LongText',
      order: 5
    }
  ];
};

const sortCMLList = ({ list }) => {
  const isNumberOnly = (v) => /^\d+$/.test(v);
  const startsWithNumber = (v) => /^\d/.test(v);
  // const startsWithLetter = (v) => /^[a-zA-Z]/.test(v);

  const sorted = list.sort((a1, b1) => {
    // pure numbers first
    let a = a1.cmlNumber;
    let b = b1.cmlNumber;
    if (isNumberOnly(a) && isNumberOnly(b)) {
      return Number(a) - Number(b);
    }
    if (isNumberOnly(a)) return -1;
    if (isNumberOnly(b)) return 1;

    // alphanumeric starting with number
    if (startsWithNumber(a) && startsWithNumber(b)) {
      return a.localeCompare(b, undefined, { numeric: true });
    }
    if (startsWithNumber(a)) return -1;
    if (startsWithNumber(b)) return 1;

    // alphabetic starting strings
    return a.localeCompare(b, undefined, { numeric: true });
  });

  return sorted;
};

const getSchema = ({ isCML, isReading }) =>
  isCML && isReading
    ? addEditCMLSchema.concat(addEditReadingSchema)
    : isCML
    ? addEditCMLSchema
    : addEditReadingSchema;

const getDefaultValue = ({ isCML, isReading }) =>
  isCML && isReading
    ? {
        ...defaultValuesOfCML,
        ...defaultValuesOfReading
      }
    : isCML
    ? defaultValuesOfCML
    : defaultValuesOfReading;

const setDefaultValuesOnForm = ({ cachedData }) => {
  const isReconcile = cachedData?.isCached || false;
  return {
    ...cachedData,
    // reconcile data
    ...(isReconcile
      ? {
          'cmlNumber-reconcile': cachedData?.['cmlNumber-reconcile']
            ? cachedData?.['cmlNumber-reconcile']
            : cachedData?.cmlNumber || ''
        }
      : {}),
    ...(isReconcile
      ? {
          'component-reconcile': cachedData?.['component-reconcile']
            ? cachedData?.['component-reconcile']
            : cachedData?.component || ''
        }
      : {}),
    ...(isReconcile
      ? {
          'location-reconcile': cachedData?.['location-reconcile']
            ? cachedData?.['location-reconcile']
            : cachedData?.location || ''
        }
      : {}),
    ...(isReconcile
      ? {
          'orientation-reconcile': cachedData?.['orientation-reconcile']
            ? cachedData?.['orientation-reconcile']
            : cachedData?.orientation || ''
        }
      : {}),
    ...(isReconcile
      ? {
          'material-reconcile': cachedData?.['material-reconcile']
            ? cachedData?.['material-reconcile']
            : cachedData?.material || ''
        }
      : {}),
    ...(isReconcile
      ? {
          'schedule-reconcile': cachedData?.['schedule-reconcile']
            ? cachedData?.['schedule-reconcile']
            : cachedData?.schedule || ''
        }
      : {}),

    ...(isReconcile
      ? {
          'outsideDiameter-reconcile': cachedData?.['outsideDiameter-reconcile']
            ? cachedData?.['outsideDiameter-reconcile']
            : cachedData?.outsideDiameter
        }
      : {}),
    ...(isReconcile
      ? {
          'nominalDiameter-reconcile': cachedData?.['nominalDiameter-reconcile']
            ? cachedData?.['nominalDiameter-reconcile']
            : cachedData?.nominalDiameter
        }
      : {}),
    ...(isReconcile
      ? {
          'wallThickness-reconcile': cachedData?.['wallThickness-reconcile']
            ? cachedData?.['wallThickness-reconcile']
            : cachedData?.wallThickness
        }
      : {}),
    ...(isReconcile
      ? {
          'tmin-reconcile': cachedData?.['tmin-reconcile']
            ? cachedData?.['tmin-reconcile']
            : cachedData?.tmin
        }
      : {}),

    ...(isReconcile
      ? {
          'outsideDiameterOnMM-reconcile': cachedData?.['outsideDiameterOnMM-reconcile']
            ? cachedData?.['outsideDiameterOnMM-reconcile']
            : cachedData?.outsideDiameterOnMM
        }
      : {}),
    ...(isReconcile
      ? {
          'nominalDiameterOnMM-reconcile': cachedData?.['nominalDiameterOnMM-reconcile']
            ? cachedData?.['nominalDiameterOnMM-reconcile']
            : cachedData?.nominalDiameterOnMM
        }
      : {}),
    ...(isReconcile
      ? {
          'wallThicknessOnMM-reconcile': cachedData?.['wallThicknessOnMM-reconcile']
            ? cachedData?.['wallThicknessOnMM-reconcile']
            : cachedData?.wallThicknessOnMM
        }
      : {}),
    ...(isReconcile
      ? {
          'tminOnMM-reconcile': cachedData?.['tminOnMM-reconcile']
            ? cachedData?.['tminOnMM-reconcile']
            : cachedData?.tminOnMM
        }
      : {})
  };
};

const convertValue = ({ value, convertedUnit, mmToFixedValue = 5, inToFixedValue = 7 }) => {
  let val = 0;
  if (convertedUnit === 'mm') {
    val = value * 25.4;
    // return +val.toFixed(5);
    return +val.toFixed(mmToFixedValue);
  } else if (convertedUnit === 'in') {
    val = value / 25.4;
    return +val.toFixed(inToFixedValue);
  }
  return val;
};

const checkValueIsEmpty = ({ value }) => {
  return value !== null && value !== undefined && value !== '';
};

export {
  setDefaultValuesOnForm,
  getFormFieldsOfReading,
  getFormFieldsOfCML,
  sortCMLList,
  addEditCMLSchema,
  addEditReadingSchema,
  defaultValuesOfCML,
  defaultValuesOfReading,
  getSchema,
  getDefaultValue,
  convertValue,
  checkValueIsEmpty
};
